// Imágenes de decklist.

import axiosClient from '../request-client';

export const uploadDeckImage = (tournamentId: number, file: File) => {
  const formData = new FormData();
  formData.append('image', file);

  return axiosClient.post(
    `/tournaments/${tournamentId}/deck-image`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export const deleteDeckImage = (tournamentId: number) =>
  axiosClient.delete(`/tournaments/${tournamentId}/deck-image`);
